module.exports = __webpack_public_path__ + "img/pro-xtIcon5.5143cc5d.png";